import { ICertGetCIRequestParams } from '@/models/Cert/interfaces/ICertGetCIRequestParams';
import { SunnyRequestBuilder } from '@/models/Common/SunnyRequestBuilder';
import CertGetCIJSC from '@/schema/CertGetCIJSC';
import { TReqConfigValidated } from '@/services/JSCService';

export class CertRequestBuilder extends SunnyRequestBuilder {
  createGetCI(reqParams?: ICertGetCIRequestParams): TReqConfigValidated {
    return this.validate(CertGetCIJSC, reqParams).map((params) => this.makeConfig('GET', '/cert/ci', params));
  }
}
